type Props = {
  ticketsSold: number | null;
};

export function EventSalesBanner({ ticketsSold }: Props) {
  if (!ticketsSold || !Number.isSafeInteger(ticketsSold) || ticketsSold < 1) {
    return null;
  }

  const ticketLabel = ticketsSold === 1 ? 'ticket' : 'tickets';

  return (
    <div
      aria-live="polite"
      className="mx-auto mb-3 flex w-full max-w-[1400px] items-center justify-center gap-2 bg-[#fff0f4] px-4 py-2 text-center text-sm font-semibold text-[#c51667] md:text-base"
      role="status"
    >
      <svg
        aria-hidden="true"
        className="h-5 w-5 shrink-0"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          d="M13.4 2.5c.35 2.5-.45 4.05-1.7 5.35-.65.68-1.05 1.32-1.1 2.15-.55-.55-.9-1.2-1.03-1.95-1.3 1.22-2.07 2.78-2.07 4.5a4.5 4.5 0 0 0 9 0c0-2.4-1.18-4.48-3.1-5.75.13 1.17-.15 2.02-.75 2.7-.05-2.46-.85-4.57-2.25-7Z"
          fill="currentColor"
        />
      </svg>
      <span>
        {ticketsSold} {ticketLabel} sold in the past hour!
      </span>
    </div>
  );
}
